import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import React from 'react';
import { initAmplitude } from './lib/amplitude';
import { onCookieConsent } from './lib/cookie-consent';

// Amplitude stores identifiers on the device, so it starts only after analytics consent.
onCookieConsent((state) => {
  if (state.analytics) initAmplitude();
});

createRoot(document.getElementById('root')!).render(<App />);
